import { NgModule } from '@angular/core';

import { DynReportsRoutingModule, routedComponents } from './dyn-reports-routing.module';
import { SharedModule } from '../shared/shared.module';
import { DynReportService } from './shared';
import { ChartModule, TreeTableModule, SharedModule as SharedModulePng, DropdownModule } from 'primeng/primeng';
import { DecimalPipe } from "@angular/common";

@NgModule({
  imports: [
    DynReportsRoutingModule,
    SharedModule,
    ChartModule,
    TreeTableModule,
    DropdownModule,
    SharedModulePng
  ],
  declarations: [
    routedComponents],
  providers: []
})
export class DynReportsModule { }



// WEBPACK FOOTER //
// ./src/app/dyn-reports/dyn-reports.module.ts